import { api } from '@/config/api';

export interface FxOverride { rate: number; note?: string; updatedAt: string; updatedBy?: string }
export interface FxTable {
  base: string;
  /** Effective: overrides win over the automatic rates. Units per 1 USD. */
  rates: Record<string, number>;
  auto: Record<string, number>;
  overrides: Record<string, FxOverride>;
  fetchedAt: string | null;
  source: string | null;
  lastError: string | null;
}

export const fxService = {
  table: async (): Promise<FxTable> => (await api.get('/super_admin/fx')).data,
  refresh: async (): Promise<FxTable> => (await api.post('/super_admin/fx/refresh')).data,
  setOverride: async (currency: string, rate: number, note?: string): Promise<FxTable> =>
    (await api.put(`/super_admin/fx/overrides/${currency}`, { rate, ...(note ? { note } : {}) })).data,
  removeOverride: async (currency: string): Promise<FxTable> =>
    (await api.delete(`/super_admin/fx/overrides/${currency}`)).data,
};
